import React from 'react';

export default function BTAXApiNotice() {
  return (
    <div className="alert alert-info" role="alert">
      BTAX API Settings is currently loaded.
    </div>
  );
}
